import { Fragment, useId, useState } from "react"
import { BaseButton } from 'components/library/buttons'
import { TPublishScenario, TScenario, TSubmitResponse } from "../scenario.model"
import { deleteUserScenario, publishScenario, startScenario, submitScenario } from '../services'
import UserRoleValidator from 'components/user/UserRoleValidator';
import callApi from "services/api/callApi";
import { KeyedMutator } from "swr";
import useToggle from "hooks/useToggle";
import DefaultModal from "components/library/DefaultModal";
import DeleteScenario from "./DeleteConfirmation";
import ResetConfirm from "./ResetConfirmation";
import useOpenTpsc from "hooks/useOpenTpsc";
import { useTranslation } from "react-i18next";
import { Language } from "utils/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import SvgImages from "components/library/SvgImages";
import Translate from "lang/Translate";

type T = any
interface CaseItemProps {
	data: TScenario,
	reload: KeyedMutator<T>,
	setEditMode: (id: TScenario) => void;
}

const CaseListItem = (props: CaseItemProps) => {
	const { data, reload } = props;
	const [loading, setLoading] = useState<boolean>(false)
	const [checked, setChecked] = useState<boolean>(data.isPublished ||  false);
	const [showDelete, setShowDelete] = useToggle()
	const [showReset, setShowReset] = useToggle();
	const ctxId = useId()
	const ctxFieldId = (fieldId: string) => [fieldId, ctxId].join("_")
	const { openTpsc } = useOpenTpsc();
	const { i18n } = useTranslation();
	const [showOptions, setShowOptions] = useState(false)

	
	const startOrReviewAScenario = async (isReview: boolean) => {
		setLoading(true)
		const { success, isLoading, data: result } = await callApi<number>("SCENARIO/START", startScenario(data.id, isReview))
		if (success) {
			reload()
			openTpsc(result)
		}
		setLoading(isLoading)
	}

	/* istanbul ignore next */
	const clearUserScenario = async () => {
		setShowReset(false)
		if (data.userScenarioId) {
			setLoading(true)
			const { success, isLoading } = await callApi<boolean>("SCENARIO/CLEAR", deleteUserScenario(data.userScenarioId))
			success && reload()
			setLoading(isLoading)
		}
	}

	/* istanbul ignore next */
	const handleSubmitScenario = async () => {
		if (data.userScenarioId) {
			setLoading(true)
			const { success, isLoading } = await callApi<TSubmitResponse>("SCENARIO/SUBMIT", submitScenario(data.userScenarioId))
			success && reload()
			setLoading(isLoading)
		}
	}

	const onPublish = async () => {
		const response = await callApi<TPublishScenario>("SCENARIO/PUBLISH", publishScenario(data.id, !checked));
		if(response && response?.success){
			setChecked(response?.data?.isPublished || false );
			reload()
		}
	}

	const setEditView = () => {
		props.setEditMode(data);
	}
	
	return (
		<div data-testid="scenarios-item" className="border-bottom p-4">
			<div className="case-list-header flex-center list-item-row">
				<div>{(i18n.language === Language.FRENCH && data.frenchName ? data.frenchName : data.name)}</div>
				<div>{data.casestudyNumber}</div>
				<div>{data.level}</div>
				<div>{data.province}</div>
				<div>{data.taxpayerName}</div>
				<UserRoleValidator validatorName="SCENARIO_PUBLISH">
				<div><input 
					type="checkbox" 
					checked={checked}
					onChange={onPublish}
					/></div>
				</UserRoleValidator>
				<div>
					{!data.userVmId ? <>
						<UserRoleValidator validatorName="SHOW_START">
							<BaseButton loading={loading} onClick={() => startOrReviewAScenario(false)} buttonStyles="is-primary is-inverted" fieldId={ctxFieldId("start")} labelKey="Buttons.start" />
						</UserRoleValidator>
						<UserRoleValidator validatorName="SHOW_REVIEW">
							<BaseButton loading={loading} onClick={() => startOrReviewAScenario(true)} buttonStyles="is-primary is-inverted" fieldId={ctxFieldId("review")} labelKey="Buttons.review" />
						</UserRoleValidator>
					</>
						:
						<>
							<BaseButton loading={loading} onClick={() => data.userVmId && openTpsc(data.userVmId)} buttonStyles="is-primary is-inverted" fieldId={ctxFieldId("continue")} labelKey="Buttons.continue" />
							<BaseButton loading={loading} onClick={() => setShowReset()} buttonStyles="is-primary is-inverted" fieldId={ctxFieldId("clear")} labelKey="Buttons.clear" />
						</>
					}
					{data.userVmId && <UserRoleValidator validatorName="SHOW_SUBMIT">
						<BaseButton loading={loading} buttonStyles="is-primary is-inverted submit-btn" fieldId={ctxFieldId("submit")} labelKey="Buttons.submit" onClick={handleSubmitScenario} isEnabled={data.submittedStatus === 0} />
					</UserRoleValidator>}

					{!data.userVmId && <>
						<UserRoleValidator validatorName="SHOW_OPEN">
							<BaseButton buttonStyles="is-text" fieldId={ctxFieldId("open")} labelKey="Buttons.open" onClick={() => openTpsc(data.vmId)} />
						</UserRoleValidator>
						{/* <UserRoleValidator validatorName="SHOW_DELETE">   
							<BaseButton buttonStyles="is-text deleteBtn" fieldId={ctxFieldId("delete")} labelKey="Buttons.delete" onClick={() => setShowDelete()}  >
						</UserRoleValidator> */}
					</>}
					<UserRoleValidator validatorName="SHOW_DELETE">
					<div className="has-text-centered scenrio-options-container" onClick={() => setShowOptions(true)}   onBlur={() => setShowOptions(false)} tabIndex={9000}>
					<FontAwesomeIcon icon={faEllipsisV} />
						{showOptions && 
						<Fragment>
							<div className="scenario-options-panel" >
								<div className="ml-1">
								{!data.isPublished && <UserRoleValidator validatorName="SHOW_DELETE">
									<div className="scenario-options-item" onClick={setEditView}>
										<SvgImages wrapperClassNames={"option-icon"} imgKey="editIcon"  />
											<span><Translate text="Buttons.edit" /></span>
									</div>
								</UserRoleValidator>}
								</div>
								<div className="ml-1">
								<UserRoleValidator validatorName="SHOW_DELETE">
								<div className="scenario-options-item delete-option" onClick={() => setShowDelete()}>
									<SvgImages wrapperClassNames={"option-icon"} imgKey="deleteIcon"  />
										<span><Translate text="Buttons.delete" /></span>
								</div>
								</UserRoleValidator>
								</div>
						</div>
					</Fragment>}
				</div>
				</UserRoleValidator>	
				</div>
					

			</div>
			<DefaultModal isOpen={showDelete} handleCloseModal={() => setShowDelete(false)}>
				<DeleteScenario reload={reload} id={data.id} />
			</DefaultModal>
			<DefaultModal isOpen={showReset} handleCloseModal={() => setShowReset(false)}>
				<ResetConfirm confirm={clearUserScenario} />
			</DefaultModal>
		</div>
	)
}

export default CaseListItem